var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe"},[_c('fixed-header'),(_vm.showIframe)?_c('iframe',{staticClass:"iframe__main scroll-touch",attrs:{"src":_vm.link}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }